import React from "react";
import { Grid, Card, CardHeader, CardContent, TextField } from "@mui/material";
import { EmojiEvents as TrophyIcon } from "@mui/icons-material";
import { purple } from "@mui/material/colors";

const XPRewardsSettings = ({ settings, onSettingChange }) => {
  const xpRewardsSettings = settings.xpRewards;

  const handleInputChange = (key, value) => {
    const processedValue = parseInt(value) || 0;
    console.log(`Updating XP rewards ${key} to:`, processedValue);
    onSettingChange("xpRewards", key, processedValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card elevation={3}>
          <CardHeader
            avatar={<TrophyIcon sx={{ color: purple[500] }} />}
            title="XP Rewards System"
            subheader="Configure experience points for user actions"
            sx={{ bgcolor: purple[50] }}
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="XP Per Message"
                  type="number"
                  value={xpRewardsSettings.xp_reward_per_message || ""}
                  onChange={(e) =>
                    handleInputChange("xp_reward_per_message", e.target.value)
                  }
                  helperText="XP rewarded for sending a message"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="XP Per Room Join"
                  type="number"
                  value={xpRewardsSettings.xp_reward_per_room_join || ""}
                  onChange={(e) =>
                    handleInputChange("xp_reward_per_room_join", e.target.value)
                  }
                  helperText="XP rewarded for joining a room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="XP Per Room Create"
                  type="number"
                  value={xpRewardsSettings.xp_reward_per_room_create || ""}
                  onChange={(e) =>
                    handleInputChange(
                      "xp_reward_per_room_create",
                      e.target.value
                    )
                  }
                  helperText="XP rewarded for creating a room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="XP Per Tip Given"
                  type="number"
                  value={xpRewardsSettings.xp_reward_per_tip_given || ""}
                  onChange={(e) =>
                    handleInputChange("xp_reward_per_tip_given", e.target.value)
                  }
                  helperText="XP rewarded for giving a tip"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="XP Per Tip Received"
                  type="number"
                  value={xpRewardsSettings.xp_reward_per_tip_received || ""}
                  onChange={(e) =>
                    handleInputChange(
                      "xp_reward_per_tip_received",
                      e.target.value
                    )
                  }
                  helperText="XP rewarded for receiving a tip"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default XPRewardsSettings;
